import { Option } from '../UI/Input'

export const orderDirectionOptions: Option<string>[] = [
  { key: 'DESC', value: 'От большего к меньшему' },
  { key: 'ASC', value: 'От меньшего к большему' },
]

export const getOptionsValue = <T>(options: Option<T>[], key: T): string =>
  options?.find(({ key: k }) => k === key)?.value || String(key)
